import { useCallback, useEffect, useState } from 'react';
import { notifyError } from 'helpers/handleNotification';
import commonServices from 'services/commonServices';
import { useSave } from 'redux/store/StoreCached';
import CachedKeys from 'consts/cachedKeys';
import CacheService from 'services/CacheService';
import { isEmpty } from 'lodash';
import useGetLoadRouteList from 'hooks/others/useGetLoadRouteList';

export default ({ servicesKey = '', noneRoutesServiceKey = '' } = {}) => {
  const vendor = useGetLoadRouteList();
  const [data, setData] = useState(CacheService.serviceVendors || {});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const save = useSave();

  const refetch = () => {
    if (!isEmpty(CacheService.serviceVendors)) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const response = await commonServices.getUserVendor();
        setData(response?.data);
        save(CachedKeys.CACHED_SERVICE_VENDOR, response?.data);
        CacheService.set('serviceVendors', response?.data);
        resolve();
      } catch (error) {
        notifyError(error || '');
        setError(error);
        reject(error);
      }
    });
  };

  useEffect(() => {
    const service = data?.service || [];

    if (servicesKey) {
      save(
        servicesKey,
        service
          .filter((el) => el.isRoutePrice)
          .filter((el) => !el.v.toLowerCase().includes('deprecated')),
      );
    }

    if (noneRoutesServiceKey) {
      save(
        noneRoutesServiceKey,
        service.filter((el) => !el.isRoutePrice),
      );
    }
  }, [servicesKey, noneRoutesServiceKey, save, data]);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const response = await commonServices.getUserVendor();

        const isError = response?.data?.error;
        if (isError) {
          notifyError(isError.toString() || '');
          setError(isError);
        } else {
          setData(response?.data);
          save(CachedKeys.CACHED_SERVICE_VENDOR, response?.data);
          CacheService.set('serviceVendors', response?.data);
        }

        setLoading(false);
      } catch (error) {
        notifyError(error || '');
        setError(error);
        setLoading(false);
      }
    };

    if (!isEmpty(CacheService.serviceVendors)) {
      return;
    }

    fetch();
  }, [save]);

  const mappingFriendlyNameService = useCallback(
    (keyService) => {
      const service = data?.service || [];
      return service?.find((e) => e.k === keyService)?.v || keyService;
    },
    [data.service],
  );

  const mappingVendorNameByID = useCallback(
    (vendorId) => {
      return vendor?.find((el) => `${el.id}` === `${vendorId}`)?.v || vendorId;
    },
    [vendor],
  );

  return { data, loading, error, refetch, mappingFriendlyNameService, mappingVendorNameByID };
};
